import React, { useEffect, useState } from 'react';
import { BarChart2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { api } from '../lib/api';
import { usePilotContext } from '../hooks/usePilotContext';

export function ConfigPage() {
  const { context } = usePilotContext();
  const [forecast, setForecast] = useState(null);

  useEffect(() => {
    async function load() {
      if (!context.customer_id) return;
      try {
        const data = await api.get(`/api/forecasts/${context.customer_id}/latest`);
        setForecast(data);
      } catch (e) {
        console.error('Forecast load failed:', e);
      }
    }
    load();
  }, [context.customer_id]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold text-foreground">Forecasts</h1>
        <p className="text-muted-foreground">Layer 2 predictive defense posture.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><BarChart2 className="h-5 w-5 text-primary" />Latest Forecast</CardTitle>
          <CardDescription>Customer `{context.customer_id}` forecast output.</CardDescription>
        </CardHeader>
        <CardContent>
          {!forecast ? <p className="text-sm text-muted-foreground">No forecast generated yet.</p> : (
            <>
              <div className="mb-4 flex flex-wrap gap-2">
                <Badge variant="secondary">Sector: {forecast.sector || context.sector}</Badge>
                <Badge variant="outline">Defense score: {forecast.defense_score ?? 0}</Badge>
                <Badge variant="outline">Threat count: {forecast.threats?.length ?? 0}</Badge>
              </div>
              <pre className="overflow-x-auto rounded-md bg-secondary/40 p-3 text-xs">{JSON.stringify(forecast, null, 2)}</pre>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
